import dashboard from './dashboard';
import menus from './menus';
import utilities from './utilities';
import other from './other';
import stockcontroller from './stockcontroller';
import finance from './finance';
import reports from './reports';
import approval from './approval';
import admin from './admin';
// ==============================|| MENU ITEMS ||============================== //
function ItemList() {
    const ItemList = [dashboard];

    if (localStorage.getItem('role')) {
        const Roles = localStorage.getItem('role').split(',');
        if (Roles.includes('38') || Roles.includes('47')) {
            ItemList.push(menus);
        }
        if (Roles.includes('18') || Roles.includes('39') || Roles.includes('5') || Roles.includes('22')) {
            ItemList.push(stockcontroller);
        }
        if (Roles.includes('53')) {
            ItemList.push(reports);
        }
        if (Roles.includes('31') || Roles.includes('34')) {
            ItemList.push(finance);
        }
        if (Roles.includes('61')) {
            ItemList.push(approval);
        }
        if (Roles.includes('99')) {
            ItemList.push(admin);
        }
    }
    return ItemList;
}
const menuItems = {
    items: ItemList()
};

export default menuItems;
